var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancleReq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 11.1C10.5 11.1 8.3 13.3 8.3 16.1C8.3 18.9 10.5 21.1 13.3 21.1C16.1 21.1 18.3 18.9 18.3 16.1C18.3 13.3 16 11.1 13.3 11.1ZM15.4 17.2C15.7 17.4 15.7 17.8 15.5 18.1C15.4 18.2 15.2 18.3 15 18.3C14.8 18.3 14.7 18.2 14.6 18.1L13.2 17L11.8 18.2C11.7 18.3 11.5 18.4 11.4 18.4C11.2 18.4 11 18.3 10.9 18.2C10.7 17.9 10.7 17.5 11 17.3L12.2 16.2L11 15.1C10.7 14.9 10.7 14.5 10.9 14.2C11.1 13.9 11.5 13.9 11.8 14.1L13.2 15.3L14.6 14.1C14.9 13.9 15.3 13.9 15.5 14.2C15.7 14.5 15.7 14.9 15.4 15.1L14.2 16.2L15.4 17.2ZM14 2H10.8C10.4 0.8 9.3 0 8 0C6.7 0 5.6 0.8 5.2 2H2C0.9 2 0 2.9 0 4V19C0 20.1 0.9 21 2 21H8.1C7.5 20.4 7 19.7 6.7 19H2V4H4V5C4 6.1 4.9 7 6 7H10C11.1 7 12 6.1 12 5V4H14V9.1C14.7 9.2 15.4 9.4 16 9.7V4C16 2.9 15.1 2 14 2ZM8 4C7.5 4 7 3.6 7 3C7 2.4 7.5 2 8 2C8.5 2 9 2.4 9 3C9 3.6 8.5 4 8 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancleReq);
export default __webpack_public_path__ + "static/media/CancleReq.3f889a1a161ec7855aa1aa4086a455ba.svg";
export { ForwardRef as ReactComponent };